import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseComplaintService} from '../case-complaint.service';

@Component({
  selector: 'app-case-complaint-assign',
  templateUrl: 'assign.component.html',
})
export class CaseComplaintAssignComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: string;

  private givenCaseId: string;

  public userToAssignTo: any = {
    user: undefined,
  };

  constructor(private readonly caseComplaintService: CaseComplaintService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string, model: string): void {
    this.givenCaseId = caseId;
    this.model = model;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmAssign($event) {
    $event.preventDefault();
    this.disabled = true;
    console.log(this.userToAssignTo.user);
    this.caseComplaintService
      .assignCaseComplaint(this.model, this.userToAssignTo.user.id, {
        parameters: { id: this.caseId },
      })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = undefined;
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
